var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const SAMSUNG = "samsung";
const TIZEN = "Tizen";
const SAMSUNG_SMART_TV = "Samsung Smart Tv";
const apiMaps = [
  {
    api: "avinfo",
    methods: [
      // format =
      // [ method, capability, argument(optional)  ]
      // ['getHdmiHdcpType', 'hdcpLevel'],
      ["isHdrTvSupport", "supportsHdr10"]
    ]
  },
  {
    api: "productinfo",
    methods: [
      ["isUHDAModel", "supportsUhd"]
    ]
  },
  {
    api: "systeminfo",
    methods: [
      ["isSupportedVideoCodec", "supportsHevc", "HEVC"]
    ]
  }
];
function samsungExtension(options = {}) {
  return (context) => {
    const { avia, logger, system } = context;
    const { AviaHookType, KeyCode, MimeType, PlayerEvent, PlayerHookType, registerHook, retrieveVideoPlayer, Util } = avia;
    if (!system.userAgent.includes(TIZEN)) {
      return;
    }
    const re = /Tizen ([^\s]+)(;|\))/;
    const test = re.exec(system.userAgent);
    avia.configure({
      system: {
        device: SAMSUNG_SMART_TV,
        os: TIZEN,
        osVersion: test && test[1] || "",
        platform: avia.Platform.LINUX
      },
      keyboard: {
        map: {
          412: KeyCode.MEDIA_REWIND,
          417: KeyCode.MEDIA_FAST_FORWARD,
          416: KeyCode.MEDIA_RECORD,
          415: KeyCode.MEDIA_PLAY,
          413: KeyCode.MEDIA_STOP,
          10009: KeyCode.ESCAPE,
          10252: KeyCode.MEDIA_PLAY_PAUSE,
          10232: KeyCode.MEDIA_TRACK_PREVIOUS,
          10233: KeyCode.MEDIA_TRACK_NEXT,
          10221: KeyCode.MEDIA_CAPTIONS
        }
      }
    });
    const { tizen } = system.global;
    if (tizen == null ? void 0 : tizen.tvinputdevice) {
      const input = tizen.tvinputdevice;
      const keys = [
        "Caption",
        "Info",
        "MediaRewind",
        "MediaPause",
        "MediaFastForward",
        "MediaRecord",
        "MediaPlay",
        "MediaStop",
        "MediaPlayPause",
        "MediaTrackPrevious",
        "MediaTrackNext"
      ];
      input.getSupportedKeys().forEach((key) => {
        try {
          const { name: name2 } = key;
          if (!keys.includes(name2)) {
            return;
          }
          input.registerKey(name2);
        } catch (error) {
          logger.warn(`Unable to register key ${name}`, error);
        }
      });
    }
    if ((options == null ? void 0 : options.resetVideoStyle) !== false) {
      registerHook(AviaHookType.CREATE_PLAYER, Util.cache("samsungVideoStyleReset", () => (context2) => {
        const options2 = context2.value;
        let lastAspectRatio = null;
        const roundAspectRatio = (ratio) => {
          return Util.roundTo(ratio, 2);
        };
        const onQualityChanged = (e, player) => {
          const newWidth = e.mediaQuality.width;
          const newHeight = e.mediaQuality.height;
          const newAspectRatio = roundAspectRatio(newHeight / newWidth);
          lastAspectRatio = roundAspectRatio(lastAspectRatio);
          if (newAspectRatio !== lastAspectRatio) {
            const video = player.video;
            const videoContainer = video.parentElement;
            const screenWidth = system.global.screen.width;
            const screenHeight = system.global.screen.height;
            const scalingFactor = screenWidth / newWidth;
            let newWidthAdjusted = newWidth * scalingFactor;
            let newHeightAdjusted = newHeight * scalingFactor;
            if (newWidthAdjusted > screenWidth) {
              const widthScalingFactor = screenWidth / newWidthAdjusted;
              newWidthAdjusted = newWidthAdjusted * widthScalingFactor;
              newHeightAdjusted = newHeightAdjusted * widthScalingFactor;
            }
            if (newHeightAdjusted > screenHeight) {
              const heightScalingFactor = screenHeight / newHeightAdjusted;
              newWidthAdjusted = newWidthAdjusted * heightScalingFactor;
              newHeightAdjusted = newHeightAdjusted * heightScalingFactor;
            }
            logger.debug(`samsungExtension: Updating video dimensions to ${newWidthAdjusted} x ${newHeightAdjusted}`);
            videoContainer.style.display = "flex";
            videoContainer.style.justifyContent = "center";
            videoContainer.style.alignItems = "center";
            video.style.width = `${newWidthAdjusted}px`;
            video.style.height = `${newHeightAdjusted}px`;
            video.style.objectFit = "fill";
          }
          lastAspectRatio = newAspectRatio;
        };
        const getShakaPlayer = (player) => {
          const playbackAdapter = player.getAdapter(avia.AdapterRole.PLAYBACK);
          return playbackAdapter.player;
        };
        const registerShakaListener = (player) => {
          const shakaPlayer = getShakaPlayer(player);
          if (!shakaPlayer) {
            return;
          }
          shakaPlayer.addEventListener("mediaqualitychanged", (e) => {
            if (e.mediaQuality.contentType === "video") {
              onQualityChanged(e, player);
            }
          });
        };
        const registerEventHandlers = (player) => {
          player.on(PlayerEvent.VIDEO_ELEMENT_ADDED, (e) => {
            const { video } = e.detail;
            video.addEventListener("resize", () => {
              lastAspectRatio = video.videoHeight / video.videoWidth;
            }, { once: true });
          });
          player.on(PlayerEvent.PLAYBACK_STARTED, () => {
            if (system.global.shaka) {
              registerShakaListener(player);
            }
          });
        };
        const getPlayer = () => __async(this, null, function* () {
          try {
            const player = yield retrieveVideoPlayer(options2.id);
            registerEventHandlers(player);
          } catch (error) {
            logger.error("samsungExtension: Error retrieving video player:", error);
          }
        });
        getPlayer();
      }));
      registerHook(PlayerHookType.ATTACH_RESOURCE, Util.cache("samsungShakaConfig", () => (context2) => {
        const resource = context2.value;
        const mimeType = Util.getResourceMimeType(resource);
        if (mimeType !== MimeType.DASH) {
          return;
        }
        const samsungShakaConfig = {
          config: {
            streaming: {
              observeQualityChanges: true
            }
          }
        };
        const playbackConfig = {
          adapter: {
            options: samsungShakaConfig
          }
        };
        Util.merge(resource.playback, playbackConfig);
      }));
    }
    const { webapis } = system.global;
    if (!webapis) {
      logger.error("samsungExtension unable to find webapis");
      return;
    }
    registerHook(AviaHookType.DEVICE_CAPABILITIES, Util.cache("samsungCapabilities", () => {
      const { webapis: webapis2 } = system.global;
      return (context2) => {
        const caps = context2.value;
        apiMaps.forEach((apiMap) => {
          const methods = apiMap.methods;
          methods.forEach((a) => {
            const api = apiMap.api;
            const [method, capability, arg] = a;
            if (!webapis2[api]) {
              logger.warn(`samsungExtension: API '${api}' is not found`);
              return;
            }
            try {
              const result = webapis2[api][method](arg || void 0);
              logger.info(`samsungExtension: Attempted ${method} with ${arg || "no arg"}; result = ${result}`);
              caps[capability] = result;
            } catch (error) {
              logger.warn(`samsungExtension: Error invoking '${method}()'; ${error.message}`);
            }
          });
        });
      };
    }));
  };
}
const ID = SAMSUNG;
const extension = samsungExtension;
export {
  ID,
  SAMSUNG,
  SAMSUNG_SMART_TV,
  TIZEN,
  extension,
  samsungExtension
};
//# sourceMappingURL=avia.samsung.esm.js.map
